<template>
    <div>
         <el-form :inline="true" :model="batchOptForm" @submit.native.prevent>
             <el-form-item label="发货备注：">
                <el-input v-model.trim="batchOptForm.title" @keyup.enter.native="getListHandler" placeholder="" clearable></el-input>
            </el-form-item>
            <el-button type="primary"  plain  @click="getBatchOptListHandler($event)">查询</el-button>
            <el-button type="primary"  plain  @click="oneUpdateSim()">一键更新</el-button>
            <el-button type="primary"  plain  @click="showBatchChgStateHandler()">批量导入</el-button>
        </el-form>
        
        <el-table :data="tbpg.tableData" 
		 border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"
		 >
           <el-table-column prop="name" label="发货备注" width="150" align="center"></el-table-column>
            <el-table-column prop="totalNum" label="本次数量" align="center"></el-table-column>
            <el-table-column prop="priceNum" label="赠送金订单（含退款）" align="center"></el-table-column>
            <el-table-column prop="priceNumNo" label="赠送金订单（不含退款）" align="center"></el-table-column>
            <el-table-column prop="yuNum" label="余额订单（含退款）" align="center"></el-table-column>
            <el-table-column prop="yuNumNo" label="余额订单（不含退款）" align="center"></el-table-column>
            <el-table-column prop="pkgNum" label="套餐订单" align="center"></el-table-column>
            <el-table-column prop="createTime" label="时间" width="150" align="center"></el-table-column>
            <el-table-column label="操作" align="center"  width="180" >
                <template slot-scope="scope">
                       <el-button  type="text"  @click="importExces(scope.row.id)">数据详情</el-button>
                    <el-button  type="text"  @click="getOptFailListHandler(scope.row.id, $event)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true"  title="信息流激活数据" :visible.sync="batchOptVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('lunxun/excel/active')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=invest')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
                
                <el-form-item label="发货名称：" prop="name">
                    <el-input v-model="batchOptForm.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div> 
        </el-dialog>      
            
        <el-dialog :append-to-body="true"  title="操作失败列表" :visible.sync="optFailVisible" width="1000px" :close-on-click-modal="false">
            <el-button type="primary" @click="confirmExportDialogVisible = true" style="margin-bottom:10px;"> 导 出</el-button>
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="pkgName" label="套餐名称"></el-table-column>
                <el-table-column prop="resorceName" label="卡来源"></el-table-column>
                <el-table-column prop="oldLoseTime" label="原本过期时间"></el-table-column>
                <el-table-column prop="newLoseTime" label="导入过期时间"></el-table-column>
                <el-table-column prop="typeNickname" label="导入类型"></el-table-column>
                <el-table-column prop="disposeNickename" label="操作人"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>  
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportSimFailHandler">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true"  title="发送营销短信" :visible.sync="sendFlg" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="sendInfo" :model="sendInfo"  label-width="120px">

               <el-form-item label="发送类型：" prop="sendName" >
                    <el-radio-group v-model="sendInfo.sendName">
                        <el-radio label="未激活">未激活卡</el-radio>
                        <el-radio label="在用卡">在用卡</el-radio>
                        <el-radio label="已激活-未续费">已激活-未续费</el-radio>
                    </el-radio-group>
                </el-form-item>  

                <el-form-item label="短信模板ID：" prop="msgId">
                    <el-input v-model="sendInfo.msgId" placeholder="请试下与技术沟通后固定的模板ID内容"  clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureSendMsg">确 定</el-button>
            </div>
        </el-dialog>      


    </div>
</template>
<script>
import {getBatchOptList, getBatchOptFailList, batchChgState, exportSimChangeStateFail} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            batchOptForm: {
                state: '',
                name:'',
                title:'',
            },
             batchOptForm1: {
                state: '',
                remark:'',
            },
            batchOptVisible: false,
            batchOptVisible1: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            optFailVisible: false,
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
            confirmExportDialogVisible:false,

            changeStateRules: {
                state: [{required: true, message: '请选择变更状态', trigger: 'blur'}],
                remark: [{required: true, message: '请选择输入变更原因', trigger: 'blur'}],
            },

            cardStateOption:[],

            sendFlg:false,
            sendInfo:{
                msgId:'',//模板Id
                sendId:'',
                sendName:''
            }
        }
    },
    methods: {
        oneUpdateSim(){
            this.$confirm("系统每6小时自动更新一次，手动一键更新等待时间会较久，确定后 可退出页面晚点查询。 确定要操作吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
              common.sysRequest('lunxun/one/button', {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.getBatchOptListHandler();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
 
              })
            })
        },
        importExces(id){
             var data = {
                 id:id
             }
            this.exportExcel('/mould/download/activeInfo', data);
        },
        sendSmsMsg(row){
            this.sendInfo.sendId=row.id;
            this.sendFlg=true;
        },
        sureSendMsg(){
             common.sysRequest('lunxun/send/msg',this.sendInfo, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                     this.sendFlg=false;
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },



         downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/激活查询.xls';
                link.click();
        },

        cancel(){
              this.sendFlg=false;
            this.batchOptVisible = false;
            this.batchOptVisible1 = false;
            this.$refs.batchOptForm.resetFields();
        },
        getBatchOptListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.batchOptForm);
             common.sysRequest('lunxun/list/active', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        getOptFailListHandlerUpdate(id, $event){
                var data={
                    id:id
                }
              common.sysRequest('lunxun/list/active/update', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getBatchOptListHandler();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
 
              })
        },
        getOptFailListHandler(id, $event){
             this.$confirm("确定要删除吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then( () => {
                var data={
                    id:id
                }
              common.sysRequest('lunxun/delete/active', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getBatchOptListHandler();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
 
              })
            })
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },

        handleSuccess(res){
            if(res.code == 200){
                this.getBatchOptListHandler();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },

        showBatchChgStateHandler(){
            this.batchOptVisible = true;
        },
         showBatchChgStateHandler1(){
            this.batchOptVisible1 = true;
        },
        sureBatchChgStateHandler(){ 
            this.$refs.batchOptForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
            sureBatchChgStateHandler1(){ 
            this.$refs.batchOptForm1.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
        exportSimFailHandler(){
            let data = {"updatasId": this.currentId_fail}
            exportSimChangeStateFail(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
                this.optFailVisible = false;
            })
        },
        handleSizeChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getBatchOptListHandler();
            }
        },
        handleCurrentChange(val){
            if(this.optFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getOptFailListHandler(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getBatchOptListHandler();
            }
        }        
    },
    created () {
        this.getBatchOptListHandler();
    }
}
</script>
<style>

</style>
